import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { hasAccess } from "@/lib/roles";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      nav(hasAccess(u.role, "admin") ? "/admin" : "/library");
    } catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    setBusy(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="eyebrow mb-3">Members</div>
      <h1 className="aperture-h1 text-4xl mb-10">Sign in.</h1>
      <form onSubmit={submit} className="space-y-4 bg-white p-8 shadow-xl rounded-sm">
        <div>
          <label className="eyebrow block mb-2">Email</label>
          <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email"
            className="w-full px-4 py-3 border border-navy-10 focus:outline-none focus:border-gold text-sm rounded-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
        </div>
        <div>
          <label className="eyebrow block mb-2">Password</label>
          <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="login-password"
            className="w-full px-4 py-3 border border-navy-10 focus:outline-none focus:border-gold text-sm rounded-sm" style={{ borderColor: "rgba(10,37,64,0.15)" }} />
        </div>
        <button disabled={busy} data-testid="login-submit" className="btn-primary w-full py-3 text-xs uppercase tracking-widest rounded-sm">{busy ? "Signing in…" : "Sign in"}</button>
        <div className="pt-2 text-center">
          <Link to="/forgot-password" data-testid="login-forgot-password-link" className="text-xs text-navy/60 hover:text-gold transition-colors">Forgot your password?</Link>
        </div>
      </form>
      <div className="mt-6 text-sm text-navy/70 text-center">
        New here? <Link to="/register" data-testid="login-register-link" className="text-gold hover:underline">Create an account</Link>
      </div>
    </div>
  );
}
